import { Header, HeaderActionType, LoadingWrapper } from "ui"
import usePersonStore from "../store/personStore"
import { Card, Grid, Typography, Paper } from "@mui/material";
import { useNavigate } from "react-router";
import { useQuery } from "@apollo/client";
import { GET_COMPANY } from "../../features/graphql/query/company";
import { People, TableChart } from "@mui/icons-material";
import CompanyForm from "./components/CompanyForm";
import { SubscriptionTable } from "./components/SubscriptionTable";
import { LocationTable } from "./components/LocationTable";

const ViewCompanyInfo = ({ onBack }: { onBack: () => void }) => {
    const company = usePersonStore(state => state.company);
    const navigate = useNavigate();

    const { loading, data } = useQuery(GET_COMPANY, {
        notifyOnNetworkStatusChange: true,
        variables: {
            id: company.id
        }
    })


    const goToStudentStats = () => {
        navigate(`students`)
    }

    const headerActions: HeaderActionType[] = [{
        name: "View Children Insights",
        icon: <People />,
        action: goToStudentStats
    },
        // {
        //     name: "View Company Insights",
        //     icon: <TableChart />,
        //     action: goToCompanyStats
        // }
    ]
    const handleSelectedLocation = (locationId: string) => {
        navigate(`location/${locationId}`);
    }
    return (
        <LoadingWrapper loading={loading}>
            <Card elevation={4} style={{ width: "100%", display: "flex", padding: "16px", height: "auto" }}>
                <Grid container spacing={2}>
                    <Grid size={12}>
                        <Header title={company.name} onBack={onBack}
                            subtitle={`Paid Licenses ${company.paidUsers}, Active Licenses ${company?.activeUsers}`}
                            headerActions={headerActions} />
                    </Grid>
                    <Grid size={6}>
                        <Grid container spacing={2}>
                            <Grid size={12}>
                                <Paper component="div" variant="outlined" sx={{ padding: "1rem" }}>
                                    <Typography sx={{ paddingBottom: "1rem" }}>If you wish to make any changes, please contact support@futuresthrive.com</Typography>
                                    <CompanyForm
                                        readonly={true}
                                        initialValues={{
                                            name: data?.company?.name ?? '',
                                            type: data?.company?.type?.toUpperCase() ?? '',
                                            needParentalConsent: data?.company?.companyConsentPolicy?.needParentalConsent ?? false,
                                            autoParentalConsent: data?.company?.companyConsentPolicy?.autoParentalConsent ?? false,
                                            timeoutWindow: data?.company?.companyConsentPolicy?.timeoutWindow ?? null,
                                            abuseAtHome: data?.company?.companyInterventionPolicy?.abuseAtHome ?? false,
                                            safeAtHome: data?.company?.companyInterventionPolicy?.safeAtHome ?? false,
                                            suicide: data?.company?.companyInterventionPolicy?.suicide ?? false
                                        }}
                                    />
                                </Paper>
                            </Grid>

                        </Grid>
                    </Grid>
                    <Grid size={6}>
                        <Grid container spacing={2}>
                            <Grid size={12}>
                                <Paper component="div" variant="outlined">
                                    <SubscriptionTable subscriptions={data?.company?.companySubscriptions} />
                                </Paper>
                            </Grid>
                            <Grid size={12}>
                                <Paper component="div" variant="outlined">
                                    <LocationTable handleSelectedLocation={handleSelectedLocation} />
                                </Paper>
                            </Grid>
                        </Grid>
                    </Grid>

                </Grid>

            </Card>
        </LoadingWrapper>
    )
}
export default ViewCompanyInfo